import {css} from '@emotion/react';
import styled from '@emotion/styled';

export const Image = styled.img(
  ({theme}) => css`
    object-fit: cover;
    max-width: 404px;
    min-width: 100px;
    width: 35%;

    ${theme.respondTo(
      'md',
      css`
        width: 50%;
      `
    )};
  `
);
